eshopApp.controller('CookieConsentController', ['$scope', '$http', function($scope, $http) {

    $scope.module_visible = true;

    $scope.dismiss = function() {
        $http.post('/m/cookieconsent').success(function(){
            $scope.module_visible = false;
        });
    }

}]);